import { LoadingButton } from "@mui/lab";
import {
    Avatar,
    Box,
    Button,
    Icon,
    IconButton,
    Menu,
    MenuItem,
    Stack,
    Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import {
    CourseDto,
    CourseEmployeeDto,
    CourseService,
    EmployeeService,
} from "../../../api/psc";
import { ConfirmationDialog } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import UpsertEmployeeDialog from "../../employees/dialogs/UpsertEmployeeDialog";
import CourseRegistrationCredentials from "../dialogs/CourseRegistrationCredentials";

export default function CourseEmployeeListItem(props: {
    course: CourseDto;
    item: CourseEmployeeDto;
    onChange: () => void;
}) {
    const { openDialog, closeDialog } = useContext(DialogContext);

    const [requestInProgress, setRequestInProgress] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const viewCredentials = () => {
        openDialog(
            <CourseRegistrationCredentials
                courseEmployee={props.item}
                course={props.course}
            />
        );
    };

    const registerEmployee = () => {
        setRequestInProgress(true);
        CourseService.registerInCourse(
            props.course.id,
            props.item.employee.id,
            "1"
        )
            .then((r) => {
                props.onChange();
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    const handleEditEmployee = () => {
        openDialog(
            <UpsertEmployeeDialog employee={props.item.employee} />,
            (r) => {
                props.onChange();
            }
        );
    };

    const handleDeleteEmployee = () => {
        openDialog(
            <ConfirmationDialog
                title="آیا نسبت به حذف این کاربر اطمینان دارید؟"
                onAccept={() => {
                    EmployeeService.deleteEmployee(
                        props.item.employee.id,
                        "1"
                    ).then((r) => {
                        props.onChange();
                    });
                }}
            />
        );
    };

    return (
        <Box>
            <Stack direction="row" spacing={1} alignItems="center">
                <Avatar sx={{ width: 30, height: 30 }} />

                <Stack>
                    <Typography sx={{ flexGrow: 1 }}>
                        {props.item.employee.displayName}
                    </Typography>

                    <Typography sx={{ flexGrow: 1 }}>
                        {props.item.employee.mobileNumber}
                    </Typography>
                </Stack>

                <Box flexGrow={1} />

                {props.item.isRegistered && (
                    <Button
                        onClick={viewCredentials}
                        size="small"
                        variant="outlined"
                        color="warning"
                    >
                        مشاهده اطلاعات ورود
                    </Button>
                )}

                {!props.item.isRegistered && !props.course.isCapacityFull && (
                    <LoadingButton
                        onClick={registerEmployee}
                        loading={requestInProgress}
                        size="small"
                        variant="contained"
                        color="success"
                    >
                        ثبت نام
                    </LoadingButton>
                )}

                {!props.item.isRegistered && props.course.isCapacityFull && (
                    <LoadingButton
                        disabled
                        size="small"
                        variant="contained"
                        color="success"
                    >
                        تکمیل ظرفیت
                    </LoadingButton>
                )}

                <IconButton onClick={openMenu}>
                    <Icon>more_vertical</Icon>
                </IconButton>

                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    <MenuItem onClick={handleEditEmployee}>ویرایش</MenuItem>
                    <MenuItem onClick={handleDeleteEmployee}>حذف</MenuItem>
                </Menu>
            </Stack>
        </Box>
    );
}
